import React, { Suspense, lazy } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Builder from "./Builder";
import Dashboard from "./Dashboard";
import DocsPage from "./docs/DocsPage";
import MyPage from "./MyPage";
import Patient from "./Patient";
import UserApproval from "./UserApproval"
import History from "./History"
import Notification from "./Notification"
import Report from "./Report"
import Referral from "./Referral"
import MyProfile from "./MyProfile"
import Role from "./Role"
import BusinessEntity from "./BusinessEntity"
import User from "./User"
import CreatePatient from "./CreatePatient"
import Lab from "./Schedule"
import Vendor from "./Schedule"
import Account from "./Account"
import CreateUser from "./CreateUser"
import ViewPatient from "./ViewPatient"
import Schedule from "./Schedule"
import CreateSchedule from "./CreateSchedule"
import AddTemplateData from "./AddTemplateData"
import ViewTemplateData from "./ViewTemplateData"
import EditUser from "./EditUser"
import Status from "./Status"
import Chat from "./Chat"
import CreateStatus from "./CreateStatus"
import EditStatus from "./EditStatus"
import EditPatient from "./EditPatient"
import CreateAccount from "./CreateAccount"
import EditAccount from "./EditAccount"
import CreateBanner from "./CreateBanner"
import Calendar from "./Calendar"
import Banner from "./Banner"
import CreatePatientOne from "./CreatePatientOne"
import EditSchedule from "./EditSchedule"
import AccountTier from "./AccountTier"
import CreateTier from "./CreateTier"
import EditTier from "./EditTier"
import EditPs from "./EditPs"
import Help from "./Help"
import ImplantType from "./ImplantType"
import CreateImplant from "./CreateImplant"
import CreateBulkSchedule from "./CreateBulkSchedule"
import AccountStatus from "./AccountStatus"
import EditAccountStatus from "./EditAccountStatus"
import ProcedureType from "./ProcedureType"
import CreateProcedure from "./CreateProcedure"
import EditProcedure from "./EditProcedure"
import AddLocation from "./AddLocation"
import BulkUpdate from "./BulkUpdate"
import SupportForm from "./SupportForm"
import EditRole from "./EditRole"
import EditBanner from "./EditBanner"
import DigitalPlanner from "./DigitalPlanner"
import ViewDigitalPlanner from "./ViewDigitalPlanner"
import JobStatus from "./JobStatus"
import CreateJobStatus from "./CreateJobStatus"
import EditJobStatus from "./EditJobStatus"
import JobServices from "./JobServices"
import CreateJobService from "./CreateJobService"
import EditJobService from "./EditJobService"
import Products from "./Products"
import RequestSummary from "./RequestSummary"
import Orders from "./Orders"

import OrderStatus from "./OrderStatus"
import CreateOrderStatus from "./CreateOrderStatus"
import EditOrderStatus from "./EditOrderStatus"

import SalesReport from "./SalesReport"

import WalletReport from "./WalletReport"


import Inventories from "./Inventories"
import BulkOrder from "./BulkOrder"


import { LayoutSplashScreen } from "../../../_metronic";
import ComparisonReport from "./ComparisonReport";
import InventoryReport from "./InventoryReport";


const GoogleMaterialPage = lazy(() =>
  import("./google-material/GoogleMaterialPage")
);
const ReactBootstrapPage = lazy(() =>
  import("./react-bootstrap/ReactBootstrapPage")
);

export default function HomePage() {

  

  // useEffect(() => {
  //   console.log('Home page');
  // }, []) // [] - is required if you need only one call
  // https://reactjs.org/docs/hooks-reference.html#useeffect

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          /* Redirect from root URL to /dashboard. */
          <Redirect exact from="/" to="/dashboard" />
        }
        
        <Route path="/builder" component={Builder} />
        <Route path="/dashboard" component={Dashboard} />
        <Route path="/google-material" component={GoogleMaterialPage} />
        <Route path="/react-bootstrap" component={ReactBootstrapPage} />
        <Route path="/my-page" component={MyPage} />
        <Route path="/patient" component={Patient} />
        <Route path="/approval" component={UserApproval} />
        <Route path="/report" component={Report} />
        <Route path="/history" component={History} />
        <Route path="/inventories" component={Inventories} />
        <Route path="/referral" component={Referral} />
        <Route path="/notification" component={Notification} />s
        <Route path="/role" component={Role} />
        <Route path="/businessentity" component={BusinessEntity} />
        <Route path="/myprofile" component={MyProfile} />
        <Route path="/user" component={User}/>
        <Route path="/docs" component={DocsPage} />
        <Route path="/account" component={Account} />
        <Route path="/lab" component={Schedule} />
        <Route path="/vendor" component={Schedule} />
        <Route path="/viewpatient" component={ViewPatient} />
        <Route path="/createpatient" component={CreatePatient} />
        <Route path="/createschedule" component={CreateSchedule} />
        <Route path="/createuser" component={CreateUser} />
        <Route path="/schedule" component={Schedule} />
        <Route path="/addtemplatedata" component={AddTemplateData} />
        <Route path="/status" component={Status} />
        <Route path="/chat" component={Chat} />
        <Route path="/createstatus" component={CreateStatus} />
        <Route path="/edituser" component={EditUser} />
        <Route path="/viewtemplatedata" component={ViewTemplateData} />
        <Route path="/editstatus" component={EditStatus} />
        <Route path="/editpatient" component={EditPatient} />
        <Route path="/createaccount" component={CreateAccount} />
        <Route path="/editaccount" component={EditAccount} />
        <Route path="/createbanner" component={CreateBanner} />
        <Route path="/calendar" component={Calendar} />
        <Route path="/banner" component={Banner} />
        <Route path="/createpatientone" component={CreatePatientOne} />
        <Route path="/editschedule" component={EditSchedule} />
        <Route path="/accounttier" component={AccountTier} />
        <Route path="/edittier" component={EditTier} />
        <Route path="/createtier" component={CreateTier} />
        <Route path="/editps" component={EditPs} />
        <Route path="/help" component={Help} />
        <Route path="/implanttype" component={ImplantType} />
        <Route path="/createimplant" component={CreateImplant} />
        <Route path="/bulktodo" component={CreateBulkSchedule} />
        <Route path="/accstatus" component={AccountStatus} />
        <Route path="/editaccstatus" component={EditAccountStatus} />
        <Route path="/proceduretype" component={ProcedureType} />
        <Route path="/editprocedure" component={EditProcedure} />
        <Route path="/createprocedure" component={CreateProcedure} />
        <Route path="/addlocation" component={AddLocation} />
        <Route path="/bulkupdate" component={BulkUpdate} />
        <Route path="/support" component={SupportForm} />
        <Route path="/editrole" component={EditRole} />
        <Route path="/editbanner" component={EditBanner} />
        <Route path="/digitalplanning" component={DigitalPlanner} />
        <Route path="/viewplanner" component={ViewDigitalPlanner} />
        <Route path="/jobstatus" component={JobStatus} />
        <Route path="/createjobstatus" component={CreateJobStatus} />
        <Route path="/editjobstatus" component={EditJobStatus} />
        <Route path="/jobservice" component={JobServices} />
        <Route path="/createjobservice" component={CreateJobService} />
        <Route path="/editjobservice" component={EditJobService} />
        <Route path="/products" component={Products} />
        <Route path="/summary" component={RequestSummary} />
        <Route path="/orders" component={Orders} />
        <Route path="/orderstatus" component={OrderStatus} />
        <Route path="/createorderstatus" component={CreateOrderStatus} />
        <Route path="/editorderstatus" component={EditOrderStatus} />
        <Route path="/salesreport" component={SalesReport} />
        <Route path="/salescompare" component={ComparisonReport} />
        <Route path="/walletcompare" component={WalletReport} />
        <Route path="/stocksinventory" component={InventoryReport} />
        <Route path="/bulkorder" component={BulkOrder} />

        
        
        <Redirect to="/error/error-v1" />
      </Switch>
    </Suspense>
  );
}
